import { render, staticRenderFns } from "./LevelForm.vue?vue&type=template&id=309920a4&scoped=true&"
import script from "./LevelForm.vue?vue&type=script&lang=js&"
export * from "./LevelForm.vue?vue&type=script&lang=js&"
import style0 from "./LevelForm.vue?vue&type=style&index=0&id=309920a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309920a4",
  null
  
)

export default component.exports